import { useFormContext } from 'react-hook-form';

import type { CheckboxData } from './types';
import { useCheckboxState } from './use-checkbox-state';

interface UseFormCheckboxArgs {
  data: CheckboxData[];
  options?: {
    prefix?: string;
    suffix?: string;
  };
}

export function useFormCheckbox(args: UseFormCheckboxArgs) {
  const { data, options = {} } = args;
  const { prefix, suffix } = options;

  const { watch, setValue } = useFormContext();

  const getValuesWithPrefix = () => {
    return prefix ? watch(prefix) : watch();
  };

  const setValueWithNameOption = (name: string, value: boolean) => {
    const fullName = [prefix, name, suffix].filter((part) => part !== undefined).join('.');
    setValue(fullName, value);
  };

  const hooks = useCheckboxState({
    data,
    values: getValuesWithPrefix(),
    setValue: setValueWithNameOption,
  });

  return hooks;
}
